import logger from '~/services/logger';

/**
 * Extracts metadata from the input data object if the screen.id property exists.
 * @param data - The input data object from remix loader.
 * @param screenIdOverride - Optional override for the screen ID.
 * @returns An array that contains the metadata and a link object if they exists.
 */
export function cssVarsMetaFunctionData(data: any, screenIdOverride?: string) {
  try {
    const screenId = screenIdOverride || data?.screen?.id;

    if (!screenId) throw new Error('Screen ID is missing in the input data');

    const hash = data?.hash;

    if (!hash) throw new Error('Hash is missing in the input data');

    const encodedScreenId = encodeURIComponent(screenId);

    const encodedHash = encodeURIComponent(hash);

    const dynamicIdFallback = data?.dynamicIdFallback;

    const dynamicIdFallbackParam = dynamicIdFallback
      ? `&dynamicIdFallback=${encodeURIComponent(dynamicIdFallback)}`
      : '';

    const layoutIdOverride = data?.layoutIdOverride;

    const layoutIdOverrideParam = layoutIdOverride
      ? `&layoutId=${encodeURIComponent(layoutIdOverride)}`
      : '';

    const href = `/css-vars-v2.css?screenId=${encodedScreenId}&hash=${encodedHash}${dynamicIdFallbackParam}${layoutIdOverrideParam}`;

    return [
      {
        tagName: 'link',
        rel: 'stylesheet',
        href,
        as: 'style',
      },
    ];
  } catch (error: any) {
    logger.error(`####### cssVarsMetaFunctionData: ${error.message}`);
    return [];
  }
}

/**
 * Extracts additional search screen ID from the input data object.
 * Used for loading CSS vars for the search screen and the search fallback screen.
 * @param data - The input data object from remix loader.
 * @returns The additional search screen ID if it exists, otherwise undefined.
 */
export function getAdditionalSearchScreenId(data: any): string | undefined {
  const searchScreen = data?.screens?.find(
    (screen: any) => screen.type === 'search_v2'
  );

  const screenId = data?.screen?.id;
  const searchScreenId = searchScreen?.id;
  const fallbackSearchScreenId = searchScreen?.general?.fallback;

  if (screenId === fallbackSearchScreenId) return searchScreenId;
  return fallbackSearchScreenId;
}
